import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, ChangePasswordDialogueHandler } from '../types';
import ChangeUserPasswordContext from './ChangeUserPasswordContext';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type ChangePasswordDialogueProps = {
  handleDialogue: DialogueHandler<ChangePasswordDialogueHandler>;
};

type FC = FunctionComponent<ChangePasswordDialogueProps>;

const ChangePasswordDialogue: FC = ({ handleDialogue }: ChangePasswordDialogueProps) => {
  const { showChangeUserPasswordSuccessAlert, showChangeUserPasswordErrorAlert, ChangeUserPasswordError } =
    useContext(ChangeUserPasswordContext);
  const { t } = useTranslation('translations', { keyPrefix: 'Users.ChangeUserPassword.Dialog' });
  return useMemo(
    () => (
      <div>
        {/* Change Password Error */}
        <ConfirmationDialogue
          isVisible={showChangeUserPasswordErrorAlert}
          title={t('ChangePasswordError.title')}
          status="error"
          subTitle={`${ChangeUserPasswordError}`}
          confirm={{
            label: t('ChangePasswordError.confirmButton'),
            action: () => handleDialogue({ type: 'change', state: 'fail' }),
          }}
        />
        {/* Change Password Success */}
        <ConfirmationDialogue
          isVisible={showChangeUserPasswordSuccessAlert}
          title={t('ChangePasswordSuccess.title')}
          status="success"
          subTitle={t('ChangePasswordSuccess.subTitle')}
          confirm={{
            label: t('ChangePasswordSuccess.confirmButton'),
            action: () => handleDialogue({ type: 'change', state: 'success' }),
          }}
        />
      </div>
    ),
    [showChangeUserPasswordSuccessAlert, showChangeUserPasswordErrorAlert],
  );
};

export default ChangePasswordDialogue;
